import {
  INIT_DISCOVERY,
  FETCH_INVITE_SUCCESS,
  FETCH_FIRM_SUCCESS,
  FETCH_CARDS_SUCCESS,
  PROCESSED_DISCOVERY_SET,
  FETCH_DISCOVERY_SET_SUCCESS,
  UPDATE_GRID_TOOL_PROGRESS,
  UPDATE_MONEY_FOCUS_TOOL_PROGRESS,
  UPDATE_DECISION_FOCUS_TOOL_PROGRESS,
  UPDATE_HEALTH_AND_HAPPINESS_FOCUS_TOOL_PROGRESS,
  CLIENT_DETAIL_CHANGE,
  SAVE_INVITE_CONVERSION_SUCCESS,
  SAVE_CLIENT_SUCCESS,
  SAVE_INVITE_CONVERSION_FAILURE,
  SET_RESET_DISCOVERY_SET_LOADING,
  SET_RESET_FOCUS_TOOL_LOADING,
  CLEAR_INVITE_ID,
  SAVE_CLIENT_FAILURE,
  SAVE_CLIENT_ENQUIRY_REQUEST,
  SAVE_CLIENT_ENQUIRY_SUCCESS,
  SAVE_CLIENT_ENQUIRY_FAILURE,
} from './constants'

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [INIT_DISCOVERY]: (state, {inviteId}) => ({ ...state, inviteId }),
  [CLEAR_INVITE_ID]: (state) => ({ ...state, inviteId: undefined }),
  [FETCH_CARDS_SUCCESS]: (state, action) => ({ ...state, discoveryCards: action.data }),
  [FETCH_INVITE_SUCCESS]: (state, {data}) => ({ ...state, invite: data }),
  [CLIENT_DETAIL_CHANGE]: (state, { hasEnquiry, isConverting, firstName, lastName, email, phone, contactTimes }) => {
    if (isConverting) {
      return {
        ...state,
        invite: {
          ...state.invite,
          client: {
            ...state.invite.client, firstName, lastName, email
          }
        },
        isClientDetailsUpdateLoading: true
      }
    } else {
      return state
    }
  },
  [SAVE_CLIENT_ENQUIRY_REQUEST]: (state) => ({ ...state, isClientDetailsUpdateLoading: true }),
  [SAVE_CLIENT_ENQUIRY_SUCCESS]: (state) => ({
    ...state,
    isClientDetailsUpdateLoading: false,
    hasEnquiredSuccess: true,
    hasEnquiredFailure: false,
  }),
  [SAVE_CLIENT_ENQUIRY_FAILURE]: (state) => ({
    ...state,
    isClientDetailsUpdateLoading: false,
    hasEnquiredSuccess: false,
    hasEnquiredFailure: true,
  }),
  [SAVE_CLIENT_SUCCESS]: (state, {client}) => ({
    ...state,
    invite: {
      ...state.invite,
      client: {
        ...state.invite.client
      }
    },
    hasUpdatedClientSuccess: true,
    hasUpdatedClientFailure: false
  }),
  [SAVE_CLIENT_FAILURE]: (state) => ({
    ...state,
    hasUpdatedClientSuccess: false,
    hasUpdatedClientFailure: true,
    isClientDetailsUpdateLoading: false
  }),
  [SAVE_INVITE_CONVERSION_SUCCESS]: (state, {data: {client}}) => ({
    ...state,
    invite: {
      ...state.invite,
      client
    },
    hasUpdatedClientSuccess: true,
    hasUpdatedClientFailure: false,
    isClientDetailsUpdateLoading: false
  }),
  [SAVE_INVITE_CONVERSION_FAILURE]: (state) => ({
    ...state,
    hasUpdatedClientSuccess: false,
    hasUpdatedClientFailure: true,
    isClientDetailsUpdateLoading: false
  }),
  [FETCH_FIRM_SUCCESS]: (state, {data}) => ({ ...state, firm: data }),
  [PROCESSED_DISCOVERY_SET]: (state) => ({ ...state, discoverySetProcessed: true }),
  [FETCH_DISCOVERY_SET_SUCCESS]: (state, action) => ({ ...state, discoverySet: action.data }),
  [UPDATE_GRID_TOOL_PROGRESS]: (state, { discoveryGridStatus }) => ({
    ...state,
    discoverySet: {
     ...state.discoverySet, discoveryGridStatus
    }
  }),
  [UPDATE_MONEY_FOCUS_TOOL_PROGRESS]: (state, {moneyFocusToolStatus}) => ({
   ...state,
   discoverySet: {
     ...state.discoverySet, moneyFocusToolStatus
   }
  }),
  [UPDATE_DECISION_FOCUS_TOOL_PROGRESS]: (state, {decisionMakingFocusToolStatus}) => ({
   ...state,
   discoverySet: {
     ...state.discoverySet, decisionMakingFocusToolStatus
   }
  }),
  [UPDATE_HEALTH_AND_HAPPINESS_FOCUS_TOOL_PROGRESS]: (state, {healthHappinessFocusToolStatus}) => ({
   ...state,
   discoverySet: {
     ...state.discoverySet, healthHappinessFocusToolStatus
   }
  }),
  [SET_RESET_FOCUS_TOOL_LOADING]: (state, {isResetFocusLoading}) => ({ ...state, isResetFocusLoading }),
  [SET_RESET_DISCOVERY_SET_LOADING]: (state, {isResetDiscoverySetLoading}) => ({ ...state, isResetDiscoverySetLoading })
}

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  discoverySetProcessed: false,
  inviteId: null,
  invite: null,
  firm: null,
  discoveryCards: [],
	discoverySet: {},
  isResetFocusLoading: false,
  isResetDiscoverySetLoading: false,
  isClientDetailsUpdateLoading: false,
  hasUpdatedClientSuccess: false,
  hasUpdatedClientFailure: false,
  hasEnquiredSuccess: false,
  hasEnquiredFailure: false,
}

export function localStorageStateSlicer({inviteId}) {
  return {
    inviteId
  }
}

export default function discoveryReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/modules/reducer.js
 **/